const createDefaultSinvoiceCustomerConfig = () => ({
    id: null,
    idSchool: null,
    username: "",
    password: "",
    taxCode: "",
    companyName: "",
    bankName: "",
    bankAccount: "",
    address: "",
    phone: "",
    email: "",
    representativeName: "",
    representativePosition: "",
    representativePhone: "",
    representativeEmail: "",
    certificateSerial: "",
    invoiceTemplate: "",
    invoiceSerial: "",
    templateCode: "",
    invoiceSeries: "",
    isActive: true,
    note: "",
    usbDigitalSignature: false,
    representativeDocumentNumber: "",
    representativeBirthDate: "",
});

const mapApiDataToCustomerConfig = (raw = {}) => ({
    id: raw.id ?? null,
    idSchool: raw.schoolId ?? raw.idSchool ?? null,
    username: raw.username ?? "",
    password: raw.password ?? "",
    taxCode: raw.taxCode ?? "",
    companyName: raw.companyName ?? "",
    bankName: raw.bankName ?? "",
    bankAccount: raw.bankAccount ?? "",
    address: raw.address ?? "",
    phone: raw.phone ?? "",
    email: raw.email ?? "",
    representativeName: raw.representativeName ?? "",
    representativePosition: raw.representativePosition ?? "",
    representativePhone: raw.representativePhone ?? "",
    representativeEmail: raw.representativeEmail ?? "",
    certificateSerial: raw.certificateSerial ?? "",
    invoiceTemplate: raw.invoiceTemplate ?? "",
    invoiceSerial: raw.invoiceSerial ?? "",
    templateCode: raw.templateCode ?? "",
    invoiceSeries: raw.invoiceSeries ?? "",
    isActive: raw.delActive !== undefined ? raw.delActive : (raw.isActive !== undefined ? raw.isActive : true),
    note: raw.note ?? "",
    usbDigitalSignature: raw.usbDigitalSignature !== undefined ? !!raw.usbDigitalSignature : false,
    representativeDocumentNumber: raw.representativeDocumentNumber ?? "",
    representativeBirthDate: raw.representativeBirthDate ?? "",
});

export const sinvoiceCustomerConfigStore = {
    namespaced: true,
    state: {
        customerConfig: createDefaultSinvoiceCustomerConfig(),
        hasData: false,
    },
    getters: {
        customerConfig: (state) => state.customerConfig,
        hasData: (state) => state.hasData,
    },
    mutations: {
        SET_CUSTOMER_CONFIG(state, payload) {
            state.customerConfig = {
                ...createDefaultSinvoiceCustomerConfig(),
                ...(payload || {}),
            };
            state.hasData = !!(state.customerConfig && state.customerConfig.id !== null && state.customerConfig.id !== undefined);
        },
        CLEAR_CUSTOMER_CONFIG(state) {
            state.customerConfig = createDefaultSinvoiceCustomerConfig();
            state.hasData = false;
        },
    },
    actions: {
        setCustomerConfig({commit}, payload) {
            commit("SET_CUSTOMER_CONFIG", payload);
        },
        setFromApiData({commit}, raw) {
            commit("SET_CUSTOMER_CONFIG", mapApiDataToCustomerConfig(raw));
        },
        clearCustomerConfig({commit}) {
            commit("CLEAR_CUSTOMER_CONFIG");
        },
    },
};

export {createDefaultSinvoiceCustomerConfig, mapApiDataToCustomerConfig};

